// src/components/MiniContact.js
import React from 'react';
import ContactForm from './ContactForm';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK, EMAIL, ADDRESS } from '../config';

function MiniContact() {
  return (
    <>
      <footer id="footer">
        <div className="footer-container">
          <div className="footer-form">
            <h3>רוצים לדבר איתנו? נחזור אליכם בהקדם!</h3>
            <ContactForm />
          </div>
          <div className="footer-map">
            <h3>מצאו אותנו</h3>
            <ul className="footer-contact-list">
              <li>
                <a href={`tel:${PHONE_TEL}`}><i className="fa fa-phone"></i> {PHONE_DISPLAY}</a>
              </li>
              <li>
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i> שלחו הודעת וואטסאפ</a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`}><i className="fa fa-envelope"></i> {EMAIL}</a>
              </li>
              <li>
                <span><i className="fa fa-map-marker-alt"></i> {ADDRESS}</span>
              </li>
            </ul>
            <div className="footer-nav-buttons">
              <a
                className="button nav-app-button waze"
                href={`https://waze.com/ul?q=${encodeURIComponent(ADDRESS)}&navigate=yes`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-map-marker-alt icon"></i> ניווט עם Waze
              </a>
              <a
                className="button nav-app-button"
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-map-marker-alt icon"></i> Google Maps
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div id="copyright">
        <ul><li>© כל הזכויות שמורות לדביר הנדסה ובניה</li></ul>
      </div>
    </>
  );
}

export default MiniContact;
